import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {fromEvent} from 'rxjs/observable/fromEvent';

@Injectable()
export class KeyboardService {
  documentKeyupObservable: Observable<any>;

  constructor() {
    this.documentKeyupObservable = fromEvent(document, 'keyup');
  }

  onDocumentKeyupObservable(): Observable<KeyboardEvent> {
    return this.documentKeyupObservable;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/keyboard/keyboard.service.ts